import {useTranslation} from "react-i18next";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from "@mui/material";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMore";
import * as React from "react";
import {useState} from "react";
import {DeleteRounded, DoDisturbAltRounded, LibraryAddRounded} from "@mui/icons-material";
import AddOrderModal from "../modals/AddOrderModal";
import EmptyState from "../../../../../util/component/EmptyState";
import {PaOrder} from "../../paOrders/constants/interfaces";


/*export interface OrderConfiguration {
    orderId?: string;
    orderDescription?: string;
    cigNumber?: string;
    cupNumber?: string;

}*/

interface OrderConfigurationAccordionProps {
    orders: PaOrder[];
    remove: Function;
    append: Function;
    fields: any;
}

const OrderConfigurationAccordion = ({orders, remove, append, fields}: OrderConfigurationAccordionProps) => {
    const {t} = useTranslation(['salesmarketing'], {keyPrefix: 'businessAgreement.orderConfiguration'});
    const [openAddOrderModal, setOpenAddOrderModal] = useState<boolean>(false);

    return (
        <>
            <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreRoundedIcon/>}>
                    <Typography>{t('title')}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Box sx={{display: 'flex', justifyContent: 'flex-end'}}>
                        <Button
                            sx={{float: "right"}}
                            disabled={orders.length === 0}
                            variant={"text"} color={"accent"}
                            endIcon={<LibraryAddRounded/>} onClick={() => setOpenAddOrderModal(true)}>
                            {t('addOrder')}
                        </Button>
                    </Box>
                    {fields.length === 0 ?
                        <EmptyState icon={<DoDisturbAltRounded/>}
                                    title={t('noValuesTitle')}
                                    content={t('noValuesContent')}/>
                        : (
                            <TableContainer>
                                <Table aria-label="orders-table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>{t('cigNumber')}</TableCell>
                                            <TableCell>{t('cupNumber')}</TableCell>
                                            <TableCell>{t('orderId')}</TableCell>
                                            <TableCell>{t('orderDescription')}</TableCell>
                                            <TableCell
                                                align={"center"}>{t('delete')}</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {fields.map((row: any, index: number) => (
                                            <TableRow key={row.id}>
                                                <TableCell>{row.cig ? row.cig : ""}</TableCell>
                                                <TableCell>{row.cup ? row.cup : ""}</TableCell>
                                                <TableCell>{row.orderId ? row.orderId : ""}</TableCell>
                                                <TableCell>{row.description ? row.description : ""}</TableCell>
                                                <TableCell align={"center"}>
                                                    <IconButton
                                                        color={"accent"}
                                                        aria-label="delete"
                                                        onClick={() => remove(index)}
                                                    >
                                                        <DeleteRounded/>
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        )}
                </AccordionDetails>
            </Accordion>
            <AddOrderModal open={openAddOrderModal} handleClose={() => {
                setOpenAddOrderModal(false)
            }} append={append} orders={orders} fields={fields}/>
        </>
    )
}

export default OrderConfigurationAccordion;